export function urlWithoutAuthenticationError(value: string) {
  const url = new URL(value);
  if (!url.searchParams.has("authError")) return null;
  url.searchParams.delete("authError");
  return `${url.pathname}${url.search}${url.hash}`;
}
